// Fase 8.1 — Alert utilities: severity metadata + deep linking.

export const ALERT_SEVERITY_META = {
  critical: {
    label: "Crítica",
    badgeClass: "bg-red-100 text-red-800 border-red-200",
    dotClass: "bg-red-500",
    rowClass: "border-l-4 border-red-500",
  },
  warning: {
    label: "Advertencia",
    badgeClass: "bg-amber-100 text-amber-800 border-amber-200",
    dotClass: "bg-amber-500",
    rowClass: "border-l-4 border-amber-500",
  },
  info: {
    label: "Info",
    badgeClass: "bg-slate-100 text-slate-700 border-slate-200",
    dotClass: "bg-slate-400",
    rowClass: "border-l-4 border-slate-300",
  },
};

export const ALERT_TYPE_LABELS = {
  stalled_order: "Orden detenida",
  delivery_blocked_by_balance: "Lista con saldo",
  low_stock_critical: "Bajo stock",
  slow_moving_inventory: "Sin movimiento",
  overdue_payable: "CxP vencida",
  purchase_order_no_reception: "OC sin recepción",
};

/** Return the internal path where the user should be sent when clicking the alert. */
export function alertDeepLink(alert) {
  if (!alert) return "/alertas";
  switch (alert.entity_type) {
    case "service_order":
      return `/ordenes/${alert.entity_id}`;
    case "accounts_payable":
      return `/cuentas-por-pagar/${alert.entity_id}`;
    case "part":
      return `/inventario/kardex?part_id=${alert.entity_id}`;
    case "purchase_order":
      return `/compras/${alert.entity_id}`;
    default:
      return "/alertas";
  }
}
